// 计费单

import { HttpGetCustomerPriceList, } from '@/service/product';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import comIndex from './update'
import comAddAlert from './alertorg'
export default {
    mixins: [TableList],
    components:{
        comIndex,
        comAddAlert
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            areaList:[]
        };
    },
    created(){
        HttpGetAreaList().then(res=>{
            this.areaList = res.data.map(item=>{
                return {
                    label:item.areaName,
                    value:item.id
                }
            })
        })
    },
    methods: {
        ajaxRequest: HttpGetCustomerPriceList,
        interceptRequest(params) {
            return params
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/quotation/head/export", this.formData, {
                        executor: "request",
                        download: true,
                        method: 'post'
                    })
                    break;
                case 'delete':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params },
                        title: this.$t('global.common.delete',{defaultValue:'删除'}),
                        desc: this.$t('fbb.localemanage.confirm_delete',{defaultValue:'删除后不可恢复，是否确认删除？'}),
                        ajaxRequest: HttpDeleteCapacityOne
                    };
                    break;
                case "add":
                    // 打开弹窗
                    this.operate = {
                        title: '添加',
                        show:true,
                        width:500,
                        component: "comAddAlert",
                        showFooter:false,
                    }
                    break;
                case 'query':
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1000,
                        component: "comIndex",
                        activeid:params,
                        type:'query',
                        showFooter:false,
                    }
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "customerpriceUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit':
                    var url=this.$router.resolve({
                        name: "customerpriceUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;

            }
        },
        getOperateNodeMap(row) {
            const { id, type } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            },{
                label: '编辑',
                show: true,
                params: id,
                operate: 'edit'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "客户公司名称",
                    key: 'CN_companyName',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "客户组织名称",
                    key: 'EQ_orgId',
                    tag: 'vSelect',
                    show: true,
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                },

            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                },
                {
                    title: '客户公司名称',
                    key:'companyName',
                    render:(h,{row})=>{
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.companyName || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: '客户组织名称',
                    key:'orgId',
                    render: (h, { row }) => this.findRenderLabel(this.getSelfmanageorgList, row.orgId),
                },
                {
                    title: '最新报价有效期',
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.startDate}</div>
                            <div>{row.endDate}</div>
                        </div>
                    }
                },
                {
                    title: '库内毛利率',
                    key: 'warehouseGpm',
                    render:(h,{row})=>{
                        return <div>{row.warehouseGpm}%</div>
                    }
                },
                {
                    title: '尾程毛利率',
                    key: 'tailGpm',
                    render:(h,{row})=>{
                        return <div>{row.tailGpm}%</div>
                    }
                },
                {
                    title: '更新时间',
                    key: 'updatedAt',
                },
                
            ];
        },
    },
};




